import React from 'react';
import { observer } from 'mobx-react';

import {
  FailureImage,
  FailureViewContainer,
  FailureViewMessage,
  RetryButton
} from './styledComponents';

interface FailureViewProps {
  onRetryClick: any;
  errorMessage: any;
}

@observer
class FailureView extends React.Component<FailureViewProps> {
  render() {
    const { onRetryClick, errorMessage } = this.props;

    return (
      <FailureViewContainer className="failure-view-container">
        <FailureImage
          className="failure-view-image"
          src="https://d15dkfioxfhy94.cloudfront.net/tenxiitian_prod/website-static/connection-lost.png"
        />
        <FailureViewMessage>{errorMessage}</FailureViewMessage>
        <RetryButton onClick={onRetryClick}>Retry</RetryButton>
      </FailureViewContainer>
    );
  }
}

export { FailureView };
